import { render, staticRenderFns } from "./PersonaDescanso.vue?vue&type=template&id=e9e91342&"
import script from "./PersonaDescanso.vue?vue&type=script&lang=js&"
export * from "./PersonaDescanso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports